<template>
  <router-link
    :to="{ name: names.laboratory, params: { id: card.id } }"
    class="recent-card"
  >
    <div class="recent-card__wrap">
      <picture class="recent-card__picture">
        <SourceImage :card="card" />
        <img
          src="/img/empty/card.png"
          :alt="card.name"
          class="recent-card__img"
          loading="lazy"
        />
      </picture>
      <LaunchProduct
        class="recent-card__play"
        :card="card"
        :disableStorageUpdate="disableStorageUpdate"
      />
      <div class="recent-card__title">
        <span class="recent-card__title-text">
          {{ card.name }}
        </span>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { names } from '@/constants/routes';
import { LabData } from '@/types/LabData';
import LaunchProduct from '@/components/Card/LaunchProduct.vue';
import SourceImage from '@/components/Card/SourceImage.vue';

defineProps<{
  card: LabData;
  disableStorageUpdate?: boolean;
}>();

</script>

<style scoped lang="scss">
@import "@/assets/style/include";

$playTranslate: translate(-50%, calc(-70% - 15px));

.recent-card {
  display: block;
  position: relative;
  width: 100%;
  padding-right: $carouselGap;

  &:hover {

    .recent-card__wrap {
      border: 2px solid $colorBlue1;
    }

    .recent-card__img {
      filter: blur(6px);
      border-radius: 0 0 20px 20px;
    }
    .recent-card__title {
      opacity: 1;
    }
    :deep(.recent-card__play) {
      transform: $playTranslate scale(1);
      opacity: 1;
    }
  }
}

:deep(.recent-card__play) {
    position: absolute;
    transform: $playTranslate scale(.5);
    transition: all $transition-speed;
    opacity: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    color: white;

    svg {
      width: 30%;
      height: 35%;
    }
}

.recent-card__wrap {
  position: relative;
  overflow: hidden;
  height: 116px;
  border-radius: 14px;
  border: 2px solid $bgLight1;
  transition: border-color $transition-speed;
}

.recent-card__picture {
  height: 100%;
}

.recent-card__title {
  position: absolute;
  bottom: 0;
  width: 100%;
  max-height: 44px;
  background: white;
  box-shadow: 0 0 1px 1px white;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  opacity: 0;
  transition: opacity $transition-speed;
}

.recent-card__title-text {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;
}

@supports (display: -webkit-box) {
  .recent-card__title-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: wrap;
  }
}

.recent-card__img {
  width: 100%;
  object-fit: cover;
  transition: all $transition-speed;
  transform: scale(1.05);
}

@include media-breakpoint-down("tablet") {
  :deep(.recent-card__play) {
    display: none;
  }
}

@include media-breakpoint-down("mobile") {
  .recent-card {
    padding-left: 0;
    padding-right: 4px;
  }
  .recent-card__img {
    max-height: 180px;
  }
}
</style>
